/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum MemberProfileQuestionnaireStatus {
  InProgress = 'InProgress',
  Submitted = 'Submitted',
  ConsentNotGranted = 'ConsentNotGranted'
}
